import { useField } from 'formik';
import React, { FC } from 'react';
import FormCurrencyInput from '..';

interface FormikFormControlProps {
    name: string;
    defaultValue: number | string;
}

const FormikFormCurrency: FC<FormikFormControlProps> = ({ name, ...props }) => {
    const [field, meta, helpers] = useField(name);

    // Methods.
    const onPriceChange = (e: any, fieldValue?: string) => {
        if (fieldValue === undefined) {
            return;
        }
        const toNumber = Number(fieldValue.replace(',', '.'));

        if (isNaN(toNumber)) {
            return;
        }
        // helpers.setValue(toNumber);
        helpers.setValue(toNumber);
        helpers.setTouched(true);
    };

    // Render.
    const error = !!(meta.touched && meta.error) ? meta.error : undefined;

    return <FormCurrencyInput {...field} {...props} onChange={onPriceChange} error={error} />;
};

export default FormikFormCurrency;
